import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmployeeRegisterComponent } from './components/employee-register/employee-register.component';
import { EmployeeContainerComponent } from './employee-container.component';
import { EmployeeComponent } from './components/employee/employee.component';
import { ContractComponent } from './components/contract/contract.component';
import { ContractRegisterComponent } from './components/contract-register/contract-register.component';
import { ContractDetailComponent } from './components/contract-detail/contract-detail.component';
import { CesadosComponent } from './components/cesados/cesados.component';
import { CesadosDetailComponent } from './components/cesados-detail/cesados-detail.component';
import { CesadosReactivateComponent } from './components/cesados-reactivate/cesados-reactivate.component';
import { PermissionGuard } from '../core/guards/permission/permission.guard';

const routes: Routes = [
  {
    path: '',
    component: EmployeeContainerComponent,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' }, // Redirige a 'list'
      {
        path: 'list',
        component: EmployeeComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_ACTIVOS_ADMIN' },
      },
      {
        path: 'list/register',
        component: EmployeeRegisterComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_ACTIVOS_ADMIN' },
      },
      {
        path: 'contract',
        component: ContractComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_CONTRATOS_RENOVACIONES_ADMIN' },
      },
      {
        path: 'contract/detail/:id',
        component: ContractDetailComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_CONTRATOS_RENOVACIONES_ADMIN' },
      },
      {
        path: 'contract/register',
        component: ContractRegisterComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_CONTRATOS_RENOVACIONES_ADMIN' },
      },
      {
        path: 'cesados',
        component: CesadosComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_CESADOS_ADMIN' },
      },
      {
        path: 'cesados/detail/:id',
        component: CesadosDetailComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_CESADOS_ADMIN' },
      },
      {
        path: 'cesados/reactivate',
        component: CesadosReactivateComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_CESADOS_ADMIN' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmployeeRoutingModule {}
